import { ActivatedRoute } from '@angular/router';
import { UploadStatus } from './../../../../shared/models/upload-status';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AppStore } from '../../../../shared/store/lookup-store.service';
import { UiStateStore } from '../../../../shared/store/ui-state-store.service';
import { SendProposal } from '../../../models/send-proposal';
import { DataService } from '../../../data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JobInfo } from '../../../models/job-info';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-send-proposal',
  templateUrl: './send-proposal.component.html',
  styleUrls: ['./send-proposal.component.scss'],
})
export class SendProposalComponent implements OnInit, OnDestroy {
  form: FormGroup;
  uploadStatus: string;
  fileName?: string;
  filepath: string;
  jobId: string | null;
  accountId: string;
  jobInfo: JobInfo;
  private subscriptions: Subscription[] = [];
  constructor(
    private formBuilder: FormBuilder,
    public lookupStore: AppStore,
    public uiState: UiStateStore,
    public dataService: DataService,
    public modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getUiStoreInfo();
    this.setupForm();
    this.subscriptions.push(
    this.uiState.selectedJobId.subscribe(
      (jobId) => {
        if (!jobId) return;
        this.jobId = jobId;
        this.dataService.getJobInfo(jobId).subscribe(s => {
          this.jobInfo = s;
        });
      }
    ));
  }
  uploadFinished(status: UploadStatus) {
    this.uploadStatus = status.status;
    this.filepath = status.filePath;
    this.fileName = this.filepath.split('\\').pop();
    setTimeout(() => {
      this.uploadStatus = '';
    }, 1000);
  }
  sendProposal() {
    if (!this.form.valid) return;
    let sendPropposal = SendProposal.parse(this.form);
    sendPropposal.filePath = this.filepath;
    sendPropposal.jobId = this.jobId;
    sendPropposal.jobPosterAccountId = this.jobInfo.jobPosterAccountId;
    this.dataService
      .sendJobProposal(sendPropposal)
      .subscribe((sendProposal) => {
        this.uiState.setSuccess('Your proposal has been sent!');
        this.form.reset();
        this.modalService.dismissAll();
      });
  }
  setupForm() {
    this.form = this.formBuilder.group({
      accountId: [this.accountId],
      coverLetter: ['', Validators.required],
      filePath: [''],
      salaryType: ['', Validators.required],
      rate: ['', Validators.required],
    });
  }
  getUiStoreInfo() {
    this.uiState.authenticatedUser.subscribe((user) => {
      if (!user) return;
      this.accountId = user.accountId;
    });
  }
  ngOnDestroy() {
    this.uiState.setSelectedJobId(null);
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
